import axios from '@/utils/axios'

export function getList(keyword, applyStatus,applyTime, page, limit) {
  return axios({
    url: '/userApply/list',
    method: 'get',
    params: { keyword, applyStatus,applyTime, page, limit },
  })
}

export function count() {
  return axios({
    url: '/userApply/count',
    method: 'get',
  })
}

export function add(category,classify,reason,startTime,endTime) {
  return axios({
    url: '/userApply/add',
    method: 'post',
    params: { category,classify,reason,startTime,endTime},
  })
}

export function update(id,category,classify,reason,startTime,endTime) {
  return axios({
    url: '/userApply/update',
    method: 'put',
    params: { id,category,classify,reason,startTime,endTime},
  })
}

// export function remove(id) {
//   return request({
//     url: '/userApply/' + id,
//     method: 'delete'
//   })
// }

export function get(id) {
  return axios({
    url: '/userApply/' + id,
    method: 'get'
  })
}

export function userCancellation(id) {
  return axios({
    url: '/userApply/userCancellation',
    method: 'put',
    params: { id},
  })
}



// export function confirm_ok(params) {
//   return request({
//     url: 'userApply/confirm/reConfirmByIds',
//     method: 'post',
//     data: params
//   })
// }

// export function addCSV() {
//   return request({
//     url: '/parseFile/addCSV',
//     method: 'get'
//   })
// }

// export function updateCSV() {
//   return request({
//     url: '/parseFile/updateCSV',
//     method: 'get'
//   })
// }

